import { SWITCH_COLOR } from './action';

const initialState = false;

const reducer = (state = initialState, action) => {
    
  switch (action.type) {
    case SWITCH_COLOR:
        return !state;
    default: {
      return state;
    }
  }
};

export default reducer;
